module.exports = __webpack_public_path__ + "8a5356e9/img/product-icon-grey.b248963c.svg";